<template>
  <NuxtLink :to="menu.menu">
    {{ menu.label }}
  </NuxtLink>
</template>

<script setup lang="ts">
import type { MenuUri } from "~/@types/siteSettings"

defineProps<{
  menu: MenuUri
}>()
</script>
